// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import articleVersionEntity from './entities/article-version.json';
import articleVersionMenu from '../pages/article-version/menu.json';
import articleVersionFullForm from '../pages/article-version/forms/full.json';
import articleVersionContextForm from '../pages/article-version/forms/context.json';
import articleVersionMiniForm from '../pages/article-version/forms/mini.json';
import articleVersionLookupForm from '../pages/article-version/forms/lookup.json';
import articleVersionTableView from '../pages/article-version/views/table.json';
import articleVersionCardsView from '../pages/article-version/views/cards.json';
import articleVersionCalendarView from '../pages/article-version/views/calendar.json';
import articleVersionDashboardView from '../pages/article-version/views/dashboard.json';

/** Тип запису «Версія статті» зі сторінками пакета: меню, форми та подання з pages/article-version/. */
export const articleVersionDefinition: IRecordTypeDefinition = {
  ...articleVersionEntity,
  views: assembleViewSet({
      table: articleVersionTableView,
      cards: articleVersionCardsView,
      calendar: articleVersionCalendarView,
      dashboard: articleVersionDashboardView,
  }),
  form: articleVersionFullForm,
  forms: { full: articleVersionFullForm, context: articleVersionContextForm, mini: articleVersionMiniForm, lookup: articleVersionLookupForm },
  menu: articleVersionMenu,
} as IRecordTypeDefinition;
